import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import CompanyService from "../services/CompanyService";
import AuthenticationService from "../services/AuthenticationService";

/**
 * Handles the "Previous version" (v1) redirection, keeping the current route.
 */
export const usePreviousVersion = () => {
  const location = useLocation();
  const allowed = CompanyService.getVersionAllowed() !== 2;

  const goToPreviousVersion = useCallback(() => {
    if (!allowed) return;

    AuthenticationService.getAuthenticationToken()
      .then((res) => {
        const baseUrl = `https://www1.intiza.com/account/logontoken?token=${res}`;
        const returnUrl = location.pathname + location.search;
        window.location.replace(
          returnUrl ? `${baseUrl}&${returnUrl}` : baseUrl
        );
      })
      .catch((err) => {
        console.error("Error obteniendo token:", err);
      });
  }, [allowed, location.pathname, location.search]);

  return { allowed, goToPreviousVersion };
};
